module.exports = __webpack_public_path__ + "media/Images/icon-multi-user-o-1ac0d48e0fb246e08dca5b8da37138f3.svg";